// back to top button
function initBackToTop() {
  const backToTop = document.querySelector(".back-to-top");

  if (!backToTop) return;

  function toggleButton() {
    backToTop.style.display = window.scrollY > 300 ? "block" : "none";
  }

  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const skipLink = document.querySelector(".skip-to-content-link");

    if (skipLink) {
      setTimeout(() => {
        skipLink.focus();
      }, 500);
    }
  }

  toggleButton();

  window.addEventListener("scroll", toggleButton);
  backToTop.addEventListener("click", scrollToTop);
}

// external link warning
function initExternalLinks() {
  const links = document.querySelectorAll("a[href]");

  links.forEach((link) => {
    try {
      const href = link.getAttribute("href");
      if (!href) return;

      if (
        href.startsWith("#") ||
        href.startsWith("/") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:")
      ) {
        return;
      }

      const url = new URL(href, window.location.origin);

      if (url.hostname !== window.location.hostname) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");

        const label = link.getAttribute("aria-label") || link.textContent.trim();
        link.setAttribute("aria-label", `${label}, Redirecting to Third Party Website,(opens in a new tab)`);
      }
    } catch (err) {
      console.error("initExternalLinks: skipped a link due to error", link, err);
    }
  });
}

// hide all <hr> elements from screen readers
function initHrAccessibility() {
  document.querySelectorAll("hr").forEach((hr) => {
    hr.setAttribute("aria-hidden", "true");
  });
}

function initHeaderSearchAccessibility() {
  const searchInstances = document.querySelectorAll('.header__search');
  if (!searchInstances.length) return;

  const updateSearchVisibility = () => {
    searchInstances.forEach((searchInstance) => {
      const isHidden = window.getComputedStyle(searchInstance).display === 'none';
      searchInstance.toggleAttribute('inert', isHidden);
      searchInstance.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
    });
  };

  updateSearchVisibility();
  window.addEventListener('resize', updateSearchVisibility);
}

// form success/error message focus
function initContactSuccessFocus() {
  const focusTarget = document.getElementById('contact-status-focus');
  if (!focusTarget) return;

  const statusMessage = document.querySelector(
    '.form-status[role="status"], .form-status[role="alert"], [id$="-success"].form__message, [id$="-error"].form__message, #successMessage, .quote[aria-live="assertive"]'
  );

  if (!statusMessage) return;

  const isNewsletterStatus =
    statusMessage.id.includes('Newsletter-') || statusMessage.id.includes('ContactFooter-');
  const isFormStatus =
    isNewsletterStatus || statusMessage.id === 'contact-success' || statusMessage.id === 'successMessage';
  const refreshMessage = document.getElementById(
    isNewsletterStatus
      ? 'a11y-newsletter-refresh-message'
      : isFormStatus
        ? 'a11y-form-refresh-message'
        : 'a11y-refresh-page-message'
  );
  const statusText = statusMessage.textContent.trim();
  const refreshText = refreshMessage?.textContent.trim();

  const isError = statusMessage.getAttribute('role') === 'alert'
    || statusMessage.id.includes('error')
    || statusMessage.getAttribute('aria-live') === 'assertive';
  focusTarget.setAttribute('role', isError ? 'alert' : 'status');
  focusTarget.setAttribute('aria-live', isError ? 'assertive' : 'polite');
  focusTarget.textContent = isNewsletterStatus && refreshText
    ? `${statusText}. ${refreshText}`
    : statusText;
  focusTarget.focus();

  if (window.location.hash === '#ContactForm') {
    history.replaceState(null, '', window.location.pathname + window.location.search);
  }
}

function initQuantityChangeAnnouncements() {
  let pendingButtonAction;
  let announcement;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button.quantity__button');
      const quantityInput = button?.closest('quantity-input');
      const input = quantityInput?.querySelector('input[type="number"]');
      if (!button || !input) return;

      const action = { button, input, previousValue: input.value };
      pendingButtonAction = action;
      setTimeout(() => {
        if (pendingButtonAction === action) pendingButtonAction = undefined;
      }, 0);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const input = event.target;
    const action = pendingButtonAction;
    if (!action || action.input !== input) return;

    pendingButtonAction = undefined;
    const previousValue = Number(action.previousValue);
    const currentValue = Number(input.value);
    if (!Number.isFinite(currentValue) || currentValue === previousValue) return;

    const direction = currentValue > previousValue ? 'plus' : 'minus';
    const directionButton = action.button.closest('quantity-input')?.querySelector(
      `.quantity__button[name="${direction}"]`
    );
    const directionLabel = directionButton?.querySelector('.visually-hidden')?.textContent.trim();
    const labelledBy = input.getAttribute('aria-labelledby');
    const quantityLabel =
      input.getAttribute('aria-label') ||
      labelledBy
        ?.split(/\s+/)
        .map((id) => document.getElementById(id)?.textContent.trim())
        .filter(Boolean)
        .join(' ');
    if (!directionLabel || !quantityLabel) return;

    if (!announcement) {
      announcement = document.createElement('span');
      announcement.className = 'visually-hidden';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.setAttribute('role', 'status');
      document.body.append(announcement);
    }

    announcement.textContent = `${directionLabel}. ${quantityLabel}: ${input.value}`;
  });
}

// DOMContentLoaded listener
document.addEventListener("DOMContentLoaded", () => {
  try { initBackToTop(); } catch (e) { console.error(e); }
  try { initExternalLinks(); } catch (e) { console.error(e); }
  try { initHrAccessibility(); } catch (e) { console.error(e); }
  try { initHeaderSearchAccessibility(); } catch (e) { console.error(e); }
  try { initContactSuccessFocus(); } catch (e) { console.error(e); }
  try { initQuantityChangeAnnouncements(); } catch (e) { console.error(e); }

 });
  
//   hide br 
document.querySelectorAll('br').forEach((br) => {
  br.setAttribute('aria-hidden', 'true');
});